import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_get_billing_accessorial_charges_assigned_contractsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { accessorial_charge_template_id: number }): 
  Promise<{ result: { BillingContractLine?: { BillingContractId?: number } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.accessorial_charge_template_id)) {
      $missingRequiredInParams.push('\'accessorial_charge_template_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { accessorial_charge_template_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { BillingContractLine?: { BillingContractId?: number } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.accessorial_charge_template_id)) {
      $missingRequiredInParams.push('\'accessorial_charge_template_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { accessorial_charge_template_id: number, $keys: any[] }): 
  Promise<{ result: { BillingContractLine?: { BillingContractId?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.accessorial_charge_template_id)) {
      $missingRequiredInParams.push('\'accessorial_charge_template_id\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      accessorial_charge_template_id: number    }) {
        if(isNil($inParams.accessorial_charge_template_id)) {
          return true; 
        }
      return false;
    }
}
